<template>
    <div>
        <v-dialog v-model="dialog_einvoice" max-width="400" no-click-animation persistent transition="dialog-bottom-transition">
            <v-card v-if="$parent.displayData">
                <v-card-title noshadow class="dialog_searchbox">
                    E-Invoice <v-spacer></v-spacer><v-btn icon @click="closeDialogWeb"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text full-height class="pt-4">
                    <!-- Generate E-invoice JSON -->

                    <v-layout ma-0 row wrap margin-top-ten white-background v-if="$parent.displayData && $parent.displayData.additionalData && $parent.displayData.additionalData.eInvoiceDetails">
                        
                        <v-flex xs12 sm12 md12 mb-3 v-if="$parent.displayData.additionalData.eInvoiceDetails.irnNumber">
                            <div font12 light-theme-color>IRN Number</div>
                            <div font16>{{$parent.displayData.additionalData.eInvoiceDetails.irnNumber}}</div>
                        </v-flex>

                        <v-flex xs12 sm12 md12 mb-3 v-if="$parent.displayData.additionalData.eInvoiceDetails.ackNumber">
                            <div font12 light-theme-color>Ack Number</div>
                            <div font16>{{$parent.displayData.additionalData.eInvoiceDetails.ackNumber}}</div>
                        </v-flex>

                        <v-flex xs12 sm12 md12 v-if="$parent.displayData.additionalData.eInvoiceDetails.ackDate">
                            <div font12 light-theme-color>Ack Date</div>
                            <div font16>{{$parent.displayData.additionalData.eInvoiceDetails.ackDate | moment('DD-MMM-YYYY')}}</div>
                        </v-flex>
                    </v-layout>

                    <v-layout ma-0 row wrap v-if="!$parent.displayData.additionalData ||  ($parent.displayData && $parent.displayData.additionalData && !$parent.displayData.additionalData.eInvoiceDetails.irnNumber && !$parent.displayData.additionalData.eInvoiceDetails.ackNumber && !$parent.displayData.additionalData.eInvoiceDetails.ackDate)">
                        <v-flex xs12 sm12 md12>
                            E-Invoice not generated yet.
                        </v-flex>
                    </v-layout>

                    <v-alert type="warning" :value="true" class="mt-4" v-if="$parent.displayData && $parent.displayData.additionalData && $parent.displayData.additionalData.eInvoiceDetails && $parent.displayData.additionalData.eInvoiceDetails.irnNumber">E-invoice already generated.</v-alert>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-layout row wrap ma-0>
                        <v-flex xs6 sm6 md6 center-align style="border-right: 1px #ddd solid;">
                            <v-btn small color="blue darken-1" text @click="$parent.fn_editEInvoice">Edit Details</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align>
                            <v-btn small color="blue darken-1" text @click="$parent.fn_downloadJSON($parent.eInvoiceData, 'einvoice')">Generate JSON</v-btn>
                        </v-flex>
                    </v-layout>
                    <!-- <v-spacer></v-spacer> -->
                </v-card-actions>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>

    export default{
        data(){
            return{
                dialog_einvoice:false,
            }
        },
        methods:{
            openDialogWeb: function () {
                this.dialog_einvoice = true;
            },
            closeDialogWeb: function () {
                this.dialog_einvoice = false;
            },
        }
    }
</script>